import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Modal,Spin } from 'antd';
import { Pattern } from 'shared/constants';
import { useNavigate } from 'react-router-dom';
import styles from './ForgotPassword.module.scss';
import { AuthService } from 'services';
import smallLogo from 'assets/images/allin1logoNoText.png';
import {
  ArrowLeftOutlined,
  LoadingOutlined
} from '@ant-design/icons';
import { CFCDN } from 'modules/shop-front/shop-front-component/ProductCollection';
import { CloseOutlined } from '@ant-design/icons';
import { useAuthModalStore } from 'modules/zustand/store';

interface ForgotPasswordProps {
  email: string;
}

const ForgotPasswordModal: React.FC = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm<ForgotPasswordProps>();
  const [formError, setFormError] = useState<string>('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pageLoading, setPageLoading ] = useState<boolean>(false);
  const [loginApiError, setChangePassApiError] = useState<{
    error_code: string;
    error_message: string;
  }>();
  

  useEffect(() => {
    setFormError(loginApiError?.error_message || '');
  }, [loginApiError]);

  const onFinish = (value: ForgotPasswordProps) => {
    fetchForgotPassword(value);
  };

  const setOffForgotModal = useAuthModalStore((state)=>state.setOffForgotModal)
  const setOnLoginModal = useAuthModalStore((state)=>state.setOnLoginModal)

  const fetchForgotPassword = async (value: ForgotPasswordProps) => {
    // call API
    setPageLoading(true)
   
    try {
      const data = await AuthService.forgotPassword(value.email);
      setPageLoading(false)
      setOffForgotModal()
      setIsModalOpen(true);
     
    } catch (e: any) {
      setPageLoading(false);
      if (
        e.error_code === 'USER_NOT_FOUND' ||
        e.error_code === 'EMAIL_EXISTED'
      ) {
        setChangePassApiError(e);
      } else if (e.error_code === 'INTERNAL_SERVER')
        setFormError('Invalid email');
      else {
        setChangePassApiError(undefined);
      }
    }
  };

  const onClickSendInstructions = (e: any) => {
    e.preventDefault();
    // Do action submit if form pass validate fields
    form.validateFields().then(form.submit).catch(getError);
  };

  const getError = () => {
    const errors = form
      .getFieldsError()
      .map((item) => item.errors)
      .reduce((prev, cur) => {
        return prev.concat(cur);
      }, []);
    setFormError(errors[0]);
  };

  const onGoBack = () => {
    navigate(-1);
  };

  return (
    
    <div className="flex flex-col justify-center items-center my-2 gap-3">
   
    
      <div
        className=" text-black text-xs text-normal cursor-pointer mb-3"
      >
        {/* <ArrowLeftOutlined onClick={onGoBack} /> */}
        <div className="flex " >
            <img className="m-auto" style={{maxHeight:'70px'}} src={smallLogo} />
        </div>
      </div>
      <div className="mx-auto !w-[300px]">
        <h2 className="text-center" >Forgot your password</h2>
      </div>
      <div className="mx-auto !w-[300px]">
        <span className=" text-center">Please provide the email address for your account, and we’ll send you instructions to reset your password.</span>
      </div>
      
      <Form
        form={form}
        name="forgotPassword"
        className="flex flex-col  mx-auto"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        layout={'vertical'}
        size={'middle'}
        autoComplete="off"
        onFieldsChange={getError}
      >
        {formError && (
          <div className="flex justify-center items-center bg-[#FFE0E0] h-[32px] mb-5">
            {formError}
          </div>
        )}
        {/* Email */}
        <label htmlFor="email" className={styles['form-item-label']}>
          Email address: <span className="text-red-600">*</span>
        </label>
        <Form.Item
          className={styles['form-item']}
          name="email"
          rules={[
            {
              required: true,
              whitespace: true,
              message: 'Please input your email!',
            },
            {
              pattern: Pattern.EMAIL,
              message: 'Invalid email',
            },
          ]}
          hasFeedback
          
        >
          <Input
            type="email"
            id="email"
            className="!w-[300px] h-[40px] !rounded-md "
          />
        </Form.Item>
        {/* Forgot password */}
        <Form.Item className={styles['form-item']}>
          <button
            className="w-full flex justify-center items-center shadow mt-3 border-none text-white bg-black hover:bg-neutral-200 hover:text-black hover:shadow-md font-[450] rounded-lg text-xl py-2 text-center inline-flex items-center  mb-2 hover:-translate-y-1 transition-all duration-300"
            style={{height:'40px'}}
            onClick={onClickSendInstructions}

          >
            <LoadingOutlined  spin  className={`${pageLoading? '':'hidden'} text-xl mr-3`}/>Reset Password
          </button>
        </Form.Item>
        <Form.Item className={styles['form-item']}>
          <button
            className="w-full flex justify-center items-center shadow mt-3 border-none text-black bg-neutral-200 hover:bg-neutral-300 hover:shadow-md font-[450] rounded-lg text-xl px-5 py-2 text-center inline-flex items-center  mb-2 hover:-translate-y-1 transition-all duration-300" 
            style={{height:'40px'}}
            onClick={() => {setOffForgotModal();setOnLoginModal();}}
          >
            Back to Login
          </button>
        </Form.Item>
        {/* Modal confirm */}
        <Modal
          //title={<img className="m-auto" style={{maxHeight:'45px'}} src={smallLogo} />}
          cancelButtonProps={{ style: { display: 'none' } }}
          open={isModalOpen}
          centered
          width={500}
          closeIcon = {true}
          onCancel={()=>{setIsModalOpen(false)}}
          footer={null}
        >
          <div className="text-center">
          <div className="flex" style={{margin:'15px'}}>
            <img className="m-auto" style={{maxHeight:'80px'}} src={smallLogo} />
          </div>
            <span className="block font-semibold text-xl">
              {"Check your email for the instructions to reset your password."}
            </span>
          </div>
        </Modal>
      </Form>
     
    </div>
   
  );
};

export default ForgotPasswordModal;
